import Property4GridContainer from "../../../components/property/grid/Property4Grid";

const Property4Grid = () => {
  return <Property4GridContainer />;
};

export default Property4Grid;
